import { useQuery } from '@tanstack/react-query';
import { resolveCampaignLink } from '../services/campaignLinkService';

/**
 * Resolves a /r/{ref} campaign short link. Never cached across mounts: each
 * open is a counted hit on the BE, and the target can change between opens.
 */
export function useCampaignLink(ref: string | null) {
  return useQuery({
    queryKey: ['campaign-link', ref],
    queryFn: () => resolveCampaignLink(ref!),
    enabled: !!ref,
    retry: false,
    gcTime: 0,
    staleTime: 0,
  });
}
